import React from 'react';
import {actions, ErrorMessage, InputTypeField, TextField, SelectField, Loader} from "react-fields";
import HoverButton from '../buttons/HoverButton';
import TermsCheckboxField from "../../components/base/termsCheckbox";
import userAPI from "../api/educatorAPI";

class Educator extends React.Component {

    state = {
        vatOptions: {vat_number: this.props.user.vat_number, country_id: this.props.user.country_id},
        isLoading: false
    };

    // componentDidUpdate(prevProps, prevState) {
    //     console.log('cdu', prevProps, this.props.user);
    //     if (prevProps.user.country_id !== this.props.user.country_id ) {
    //         console.log('check country');
    //         const currentCountry = this.props.countries.find((c) => c.id === parseInt(this.props.user.country_id));
    //         console.log(currentCountry);
    //         this.props.setUser({...this.props.user, needValidateVat: (currentCountry && currentCountry.eu_vat)});
    //         this.validateVat();
    //     }
    // }

    onHandleChange = (e) => {
        let name = e.target.name;
        let user = this.props.user;
        user[name] = name === 'agree_terms' ? e.target.checked : e.target.value;
        user.errors[actions.camelize(name)] = "";
        let needRevalidateVat = false;
        if (name === 'country_id') {
            const currentCountry = this.props.countries.find((c) => c.id === parseInt(user.country_id));
            user['needValidateVat'] = (currentCountry && currentCountry.eu_vat);
            needRevalidateVat = !!user.vat_number;
        }
        if (name === 'country_id' || name === 'vat_number') {
            user['vat_valid'] = false;
            user['vat_validated_at'] = null;
        }
        this.props.setUser(user);
        if (needRevalidateVat) {this.validateVat()}
    };

    validateVat = () => {
        const currentCountry = this.props.countries.find((c) => c.id === parseInt(this.props.user.country_id));
        const needValidateVat =  (currentCountry && currentCountry.eu_vat);
        if (needValidateVat && (this.props.user.country_id !== this.state.vatOptions.country_id || this.props.user.vat_number !== this.state.vatOptions.vat_number)) {
            this.setState({isLoading: true});
            const vatOptions = {vat_number: this.props.user.vat_number, country_id: this.props.user.country_id};
            userAPI.validateVat(vatOptions, (result) => {
                this.props.setUser({...this.props.user, vat_valid: result.vat_valid, vat_validated_at: result.vat_validated_at});
                this.setState({vatOptions: vatOptions, vatValidationError: result.error_message, isLoading: false})
            }, (error) => {
                this.props.setUser({...this.props.user,  vat_valid: false, vat_validated_at: null});
                this.setState({vatOptions: vatOptions, vatValidationError: error, isLoading: false})
            });
        }
    };

    render() {
        let user = this.props.user;
        return  (
            <div className="form-container checkout-user-details">
            {this.state.isLoading ? <Loader/> : null}
            <div className="grid-x">
                <div className="cell">
                    <h3 className="license-checkout__inner__title">Your account</h3>
                </div>
                <div className="grid-x license-checkout__form-row">
                    <div className={'large-6 cell'}>
                        <TextField name="name" placeholder="Name*"
                                   errorMessage={user.errors.name}
                                   disabled={this.props.disabled}
                                   value={user.name} onChange={this.onHandleChange} />
                    </div>
                    <div className={'large-6 cell'}>
                        <InputTypeField type="email" name="email" placeholder="Email*"
                                        errorMessage={user.errors.email || user.errors.base}
                                        disabled={this.props.disabled}
                                        value={user.email} onChange={this.onHandleChange} />

                    </div>
                </div>

                <div className="cell">
                    <h3 className="license-checkout__inner__billing-title">Billing Details</h3>
                </div>
                <div className="grid-x license-checkout__form-row">
                    <div className={'cell'}>
                        <TextField name="company_name" placeholder="Company/institution name*"
                                   errorMessage={user.errors.companyName}
                                   disabled={this.props.disabled}
                                   value={user.company_name} onChange={this.onHandleChange} />
                    </div>
                </div>
                <div className="grid-x license-checkout__form-row">
                    <div className={'cell'}>
                        <TextField name="address" placeholder="Street Address*"
                                   errorMessage={user.errors.address}
                                   disabled={this.props.disabled}
                                   value={user.address} onChange={this.onHandleChange} />
                    </div>
                </div>
                <div className="grid-x license-checkout__form-row">
                    <div className={'large-6 cell'}>
                        <TextField name="city" placeholder="Town/City*"
                                   errorMessage={user.errors.city}
                                   disabled={this.props.disabled}
                                   value={user.city} onChange={this.onHandleChange} />
                    </div>
                    <div className={'large-6 cell'}>
                        <InputTypeField name="postal_code" placeholder="Postal/Zip code*"
                                        errorMessage={user.errors.postalCode}
                                        disabled={this.props.disabled}
                                        value={user.postal_code} onChange={this.onHandleChange} />
                    </div>
                </div>
                <div className="grid-x license-checkout__form-row">
                    <div className={'large-6 cell'}>
                        <SelectField name="country_id" placeholder="Country*"
                                     className="label-icon-right select-label"
                                     onChange={this.onHandleChange}
                                     options={this.props.countries} optionsValue='id' optionsLabel='name'
                                     selected={user.country_id} disabled={this.props.disabled}
                                     errorMessage={user.errors.countryId} />
                    </div>
                    <div className={'large-6 cell'}>
                        <div className={`vat-container${user.needValidateVat && user.vat_valid ? ' vat-container--valid' : ''}${user.needValidateVat && !user.vat_valid ? ' vat-container--invalid' : ''}`}>
                            <InputTypeField name="vat_number" placeholder="Tax/VAT number"
                                            errorMessage={user.errors.vatNumber} onBlur={this.validateVat}
                                            disabled={this.props.disabled}
                                            value={user.vat_number} onChange={this.onHandleChange} />
                            {this.state.vatValidationError ? <ErrorMessage message={this.state.vatValidationError} /> : null}
                        </div>

                    </div>
                </div>
                { this.props.onSubmit ?
                <div className="grid-x license-checkout__form-row">
                    {/*<div className={'cell group__button-container'}>*/}
                        {/*<HoverButton onClick={this.props.onSubmit}>Create Account</HoverButton>*/}
                    {/*</div>*/}
                    <div className="cell">
                        <div className={`license-checkout__submit`}>
                            <TermsCheckboxField name="agree_terms" value={user.agree_terms}
                                                errorMessage={user.errors.agreeTerms}
                                                onChange={this.onHandleChange} />
                            <HoverButton onClick={this.props.onSubmit}>Create Account</HoverButton>
                        </div>
                    </div>
                </div> : null}
            </div></div>
        )
    }


}
export default Educator;